import instance from "../../services/baseService";

const employeeFormConfig = {
  employeeInfo: {
    title: 'Personal Information',
    fields: [
      { key: 'job_title', label: 'Job Title', type: 'dropdown', apiKey: 'jobTitles', required: true, },
      { key: 'role', label: 'Role', type: 'dropdown', apiKey: 'roles', required: true },
      {
        key: 'name', label: 'First Name', type: 'text', required: true, validation: {
          pattern: /^[A-Za-z\s]+$/,
          message: 'Only alphabets and spaces are allowed.'
        }
      },
      {
        key: 'last_name', label: 'Last Name', type: 'text', required: false, validation: {
          pattern: /^[A-Za-z\s]+$/,
          message: 'Only alphabets and spaces are allowed.'
        }
      },
      // { key: 'username', label: 'Employee Login Username', type: 'text' },
      {
        key: 'phone', label: 'Mobile', type: 'text', validation: {
          pattern: /^[0-9]{10}$/,
          message: 'Please enter a valid 10-digit number.'
        }
      },
      {
        key: 'email', label: 'Email', type: 'email', required: true, validation: {
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: 'Please enter a valid email address.'
        }
      },
      { key: 'gender', label: 'Gender', type: 'select', options: ['Male', 'Female', 'Other'], required: false },
      { key: 'dob', label: 'DOB', type: 'date', required: false },
      { key: 'blood_group', label: 'Blood Group', type: 'select', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], required: false },
      {
        key: 'country', label: 'Nationality', type: 'text', validation: {
          pattern: /^[A-Za-z\s]+$/,
          message: 'Only alphabets and spaces are allowed.'
        }
      },
      {
        key: 'address', label: 'Address', type: 'textArea', validation: {
          pattern: /^[a-zA-Z0-9\s,.'#\/\-]{1,100}$/,
          message: 'Please enter a valid address (up to 100 characters).'
        }, required: false
      },
      {
        key: 'personal_email', label: 'Personal Email', type: 'email', required: true, validation: {
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: 'Please enter a valid email address.'
        }
      }
    ]
  },
  officialInfo: {
    title: 'Employee Official Information',
    fields: [
      {
        key: 'company_user_id',
        label: 'Employee ID',
        type: 'text',
        required: false,
        validation: {
          pattern: /^[a-zA-Z0-9]{3,10}$/,
          message: 'Please enter a valid alphanumeric ID (3 to 10 characters, e.g., EMP123)'
        }
      },
      {
        key: 'company_email', label: 'Employee Email', type: 'email', required: false, validation: {
          pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: 'Please enter a valid email address.'
        }
      }
    ]
  },
  employeeIdentity: {
    title: 'Employee Identity',
    fields: [
      { key: 'id_card_type', label: 'KYC Type', type: 'select', options: ['Aadhar Card', 'PAN Card', 'Passport', 'Driving License', 'Voter ID'], required: true },
      { key: 'photo', label: 'Upload KYC File', type: 'file', accept: 'image/*,.pdf', required: true },
      { key: 'id_card_number', label: 'KYC ID Number', type: 'text', required: true }
    ]
  },
  joiningDetails: {
    title: 'Joining Details',
    fields: [
      { key: 'joining_date', label: 'Date of Joining', type: 'date', required: false },
      { key: 'approval_date', label: 'Approval Date', type: 'date' },
      { key: 'job_status', label: 'Status', type: 'select', options: ['trainee', 'probation', 'permanent'], required: false },
      {
        key: 'notice_period', label: 'Notice Period (Days)', type: 'text', validation: {
          pattern: /^(immediate|none|n\/a|\d{1,3}\s?(day|days|month|months)?)$/i,
          message: 'Enter a valid notice period (e.g., "30 days", "2 months", or "Immediate").'
        }, required: false
      },
      // { key: 'currentCompanyExperience', label: 'Current Company Experience', type: 'text' },
      {
        key: 'total_experience', label: 'Previous Experience', type: 'text', validation: {
          pattern: /^(0|[1-9]\d{0,1})(\.\d{1,2})?$/,
          message: 'Enter valid experience in years (e.g., "2", "2.5", or "0.8").'
        }, required: false
      }
    ]
  },
  remarks: {
    title: 'Remarks',
    fields: [
      {
        key: 'remark',
        label: 'Remarks',
        type: 'textArea',
        required: false,
        validation: {
          pattern: /^.{0,500}$/,
          message: 'Remarks cannot exceed 500 characters.'
        }
      }
    ]
  }
};

export default employeeFormConfig;



export const apiService = {
  verifyExperience: async (profileId, experienceId, data) => {
    const response = await instance.post(`/api/v1/user/verify/experience/${profileId}/${experienceId}`, {
      note: data.note
    });
    return response.data;
  },
  insertExperience: async (profileId, data) => {
    const response = await instance.post(`/api/v1/user/insert/experience/${profileId}`, {
      job_title: data.job_title,
      organization: data.organization,
      type: data.type,
      start_date: data.start_date,
      end_date: data.end_date,
      total_years: data.total_years
    });
    return response.data;
  },

  updateExperience: async (profileId, experienceId, data) => {
    const response = await instance.post(`/api/v1/user/update/experience/${profileId}/${experienceId}`, {
      job_title: data.job_title,
      organization: data.organization,
      type: data.type,
      start_date: data.start_date,
      end_date: data.end_date,
      total_years: data.total_years
    });
    return response.data;
  },

  listExperience: async (profileId, page = 1, perpage = 25) => {
    const response = await instance.post(`/api/v1/user/list/experience/${profileId}`, {
      page,
      perpage,
    });
    return response.data;
  },

  deleteExperience: async (profileId, experienceId) => {
    const response = await instance.get(`/api/v1/user/delete/experience/${profileId}/${experienceId}`);
    return response.data;
  },
  updateEmployeeData: async (employeeId, data) => {
    try {
      const response = await instance.post(`/api/v1/user/update/profile/${employeeId}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating employee data:", error);
      return { type: "error", message: error.message };
    }
  },

  uploadProfilePhoto: async (userId, file) => {
    const formData = new FormData();
    formData.append("photo", file);

    try {
      const response = await instance.post(`/api/v1/user/photo/update/${userId}`, formData);
      return response.data;
    } catch (error) {
      console.error("Error uploading profile photo:", error);
      throw error;
    }
  },

  getJobTitles: async () => {
    try {
      const response = await instance.get("api/v1/user/job/list");
      const result = response.data;

      if (result.type === "success" && Array.isArray(result.data)) {
        return result.data.map(item => ({
          id: item.id,
          name: item.job_title,
        }));
      } else {
        console.error("Failed to fetch job titles:", result.message);
        return [];
      }
    } catch (error) {
      console.error("Error fetching job titles:", error);
      return [];
    }
  },

  createJobTitle: async (name) => {
    try {
      const response = await instance.post("/api/v1/user/job/create", {
        job_title: name,
      });

      const result = response.data;

      if (result.type === "success") {
        return {
          id: result.data.id,
          name: result.data.job_title,
        };
      } else {
        console.error("Failed to create job title:", result.message);
        return null;
      }
    } catch (error) {
      console.error("Error creating job title:", error);
      return null;
    }
  },
  createKYCType: async (name) => {
    try {
      const response = await instance.post("/api/v1/user/kyc/type/create", {
        label: name,
      });
      const result = response.data;
      if (result.type === "success") {
        return result;
      } else {
        console.error("Failed to create job title:", result.message);
        return null;
      }
    } catch (error) {
      console.error("Error creating job title:", error);
      return null;
    }
  },

  insertKyc: async (profileId, data) => {
    const formData = new FormData();
    formData.append("id_card_type", data.id_card_type);
    formData.append("id_card_number", data.id_card_number);
    formData.append("photo", data.photo);

    const response = await instance.post(`/api/v1/user/insert/kyc/${profileId}`, formData);
    return response.data;
  },

  updateKyc: async (profileId, kycId, data) => {
    const formData = new FormData();
    formData.append("id_card_type", data.id_card_type);
    formData.append("id_card_number", data.id_card_number);
    formData.append("is_photo_update", data.is_photo_update ? 1 : 0);
    if (data.photo && data.is_photo_update) {
      formData.append("photo", data.photo);
    }

    const response = await instance.post(`/api/v1/user/update/kyc/${profileId}/${kycId}`, formData);
    return response.data;
  },

  listKyc: async (profileId, page = 1, perpage = 25) => {
    const response = await instance.post(`/api/v1/user/list/kyc/${profileId}`, {
      page,
      perpage,
    });
    return response.data;
  },

  listKycTypes: async () => {
    const response = await instance.get("/api/v1/user/kyc/type/list", {
    });
    return response.data;
  },

  deleteKyc: async (profileId, kycId) => {
    const response = await instance.get(`/api/v1/user/delete/kyc/${profileId}/${kycId}`);
    return response.data;
  },
};


export const kycValidationRules = {
  aadhaar: {
    pattern: /^\d{12}$/,
    message: 'Aadhar must be a 12-digit number.'
  },
  pan: {
    pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    message: 'PAN must be in the format ABCDE1234F.'
  },
  passport: {
    pattern: /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/,
    message: 'Invalid Passport number.'
  },
  driving_license: {
    pattern: /^[A-Z]{2}\d{2}\s?\d{11}$/,
    message: 'Invalid Driving License number.'
  },
  voter_id: {
    pattern: /^[A-Z]{3}\d{7}$/,
    message: 'Voter ID must be in format like ABC1234567.'
  }
};


export const EXPValidationRules = {
  "job_title": {
    "required": true,
    "message": "Job title is required.",
    "pattern": "^[A-Za-z\\s]+$",
    "patternMessage": "Only alphabets and spaces are allowed in job title."
  },
  "organization": {
    "required": true,
    "message": "Organization is required.",
    "pattern": "^[A-Za-z0-9\\s]+$",
    "patternMessage": "Only alphabets, numbers, and spaces are allowed in organization name."
  },
  "type": {
    "required": true,
    "message": "Type is required."
  },
  "start_date": {
    "required": true,
    "message": "Start date is required."
  },
  "end_date": {
    "required": true,
    "message": "End date is required."
  }
}

export const employeeApprovalService = {
  approveEmployee: async (profileId, status, isApproved = true) => {
    const endpoint =
      status === 0
        ? `/api/v1/user/approve/temp/${profileId}`
        : `/api/v1/user/approve/account/${profileId}`;

    const payload = { approve: isApproved ? 1 : 2 };
    const response = await instance.post(endpoint, payload);
    return response.data;
  },
  updateCompanyInfo: async (profileId, company_email, company_user_id) => {
    const response = await instance.post(`/api/v1/user/update/info/${profileId}`, {
      company_email,
      company_user_id
    });
    return response.data;
  }
};


export const extractDropdownValue = (key, value, type = 'id') => {
  if (key === "job_title" && value && typeof value === 'object') {
    if (type === 'id') {
      return value.id;
    } else if (type === 'name') {
      return value.job_title;
    }
  }

  return value;
};